module.exports = __webpack_public_path__ + "static/media/Saira-Light.50d64350.ttf";